import React from "react";
import "./title.css";
const Title = () => {
  return (
    <header className="title">
      <h4>SQL Editor</h4>
    </header>
  );
};

export default Title;
